import React, { Component } from "react";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";

export default class BibliographyView extends Component {
  render() {
    let bibitems = [];
    if (this.props.data) {
      bibitems = this.props.data.map(function (bib, index) {
        return <li key={index}>{bib}</li>;
      });
    }

    return (
      <div style={{ backgroundColor: "white", padding: 20, margin: 10 }}>
        <h4>
          Basic Tablet Bibliography
          <Tooltip
            theme="dark"
            interactive={true}
            position="top-end"
            trigger="click"
            arrow="true"
            size="regular"
            html={
              <pre
                style={{ textAlign: "left" }}
                dangerouslySetInnerHTML={{ __html: this.props.reference }}
              ></pre>
            }
          >
            {` `}
            <span
              style={{ color: "red", cursor: "pointer" }}
              className="glyphicon glyphicon-search preview"
              aria-hidden="true"
            ></span>
          </Tooltip>
        </h4>
        <ul>{bibitems}</ul>
      </div>
      /*


</div>
  </div>
</div>
*/
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/itemscreens/BibliographyView.js